import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';

import { ROUTES, insertIdtoUrl } from 'constants/Routes.js';
import BusinessReport from 'components/businesses/tabs/reports/BusinessReport';
import CommentConfigList from 'components/emailConfig/list/CommentConfigList';
import SurveyConfigList from 'components/emailConfig/list/SurveyConfigList';
import SmsAlertConfigList from 'components/emailConfig/list/SmsAlertConfigList';
import { BUSINESS_ADMIN_NAV } from 'constants/NavRoutes';
import FeedbackReports from 'components/feedbackReport/feedbackReports';

const isReportsTabActive = currentUrl => {
  return BUSINESS_ADMIN_NAV.REPORT.includes(currentUrl);
};

const isFeedBackReportsActive = currentUrl => {
  return BUSINESS_ADMIN_NAV.FEEDBACK_REPORT.includes(currentUrl);
};

const checkActiveTab = currentUrl => {
  if (isReportsTabActive(currentUrl)) return 'reports';
  if (isFeedBackReportsActive(currentUrl))
    return ROUTES.BUSINESS_SURVEY_FEEDBACKS;

  return currentUrl;
};

const DashboardTab = ({ match }) => {
  const currentUrl = match.path;
  const activeTabName = checkActiveTab(currentUrl);
  const [activeTab, setActiveTab] = useState(activeTabName);
  const businessId = match.params.id;
  const { customSurveyId } = match.params;

  useEffect(() => {
    const currentTab = checkActiveTab(currentUrl);
    if (currentTab !== activeTab) toggle(currentTab);
  }, [currentUrl]);

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            tag={Link}
            to={insertIdtoUrl(ROUTES.REPORT_LIST, businessId)}
            onClick={() => toggle('reports')}
            className={`${classnames({
              active: activeTab === 'reports',
            })}`}
          >
            Survey Reports
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            tag={Link}
            to={insertIdtoUrl(ROUTES.BUSINESS_SURVEY_EMAIL_CONFIG, businessId)}
            onClick={() => toggle(ROUTES.BUSINESS_SURVEY_EMAIL_CONFIG)}
            className={`${classnames({
              active: activeTab === ROUTES.BUSINESS_SURVEY_EMAIL_CONFIG,
            })}`}
          >
            Survey Email
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            tag={Link}
            to={insertIdtoUrl(ROUTES.BUSINESS_COMMENT_EMAIL_CONFIG, businessId)}
            onClick={() => toggle(ROUTES.BUSINESS_COMMENT_EMAIL_CONFIG)}
            className={`${classnames({
              active: activeTab === ROUTES.BUSINESS_COMMENT_EMAIL_CONFIG,
            })}`}
          >
            Comment Email
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            tag={Link}
            to={insertIdtoUrl(ROUTES.BUSINESS_SMS_ALERT_CONFIG, businessId)}
            onClick={() => toggle(ROUTES.BUSINESS_SMS_ALERT_CONFIG)}
            className={`${classnames({
              active: activeTab === ROUTES.BUSINESS_SMS_ALERT_CONFIG,
            })}`}
          >
            Text/Sms Alert
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            tag={Link}
            to={insertIdtoUrl(ROUTES.BUSINESS_SURVEY_FEEDBACKS, businessId)}
            onClick={() => toggle(ROUTES.BUSINESS_SURVEY_FEEDBACKS)}
            className={`${classnames({
              active: activeTab === ROUTES.BUSINESS_SURVEY_FEEDBACKS,
            })}`}
          >
            Feedback Reports
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="reports">
          <BusinessReport
            businessId={businessId}
            customSurveyId={customSurveyId}
            currentUrl={currentUrl}
          />
        </TabPane>
        <TabPane tabId={ROUTES.BUSINESS_SURVEY_EMAIL_CONFIG}>
          <SurveyConfigList businessId={businessId} />
        </TabPane>
        <TabPane tabId={ROUTES.BUSINESS_COMMENT_EMAIL_CONFIG}>
          <CommentConfigList businessId={businessId} />
        </TabPane>
        <TabPane tabId={ROUTES.BUSINESS_SMS_ALERT_CONFIG}>
          <SmsAlertConfigList businessId={businessId} />
        </TabPane>
        <TabPane tabId={ROUTES.BUSINESS_SURVEY_FEEDBACKS}>
          <FeedbackReports />
        </TabPane>
      </TabContent>
    </div>
  );
};

DashboardTab.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
    params: PropTypes.shape({
      id: PropTypes.string,
      locationId: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(DashboardTab);



// WEBPACK FOOTER //
// ./src/components/tabNavBar/dashboard/DashboardTab.js